{
  "page": {
    "title": "Отчёты",
    "ariaLabel": "Типы отчётов"
  },
  "filters": {
    "timeRange": "Период",
    "employee": "Сотрудник",
    "allEmployees": "Все сотрудники",
    "employeeRequired": "Сотрудник *",
    "selectEmployee": "Выберите сотрудника…"
  },
  "templates": {
    "attendanceSummary": {
      "label": "Сводка посещаемости",
      "description": "Ежедневный обзор посещаемости со временем прихода/ухода и отработанными часами."
    },
    "payroll": {
      "label": "Зарплата",
      "description": "Расчёт зарплаты с часами, ставками и итоговой суммой по сотрудникам."
    },
    "dailyTimesheet": {
      "label": "Ежедневный табель",
      "description": "Детальная запись каждой отметки сотрудника за день."
    },
    "lateAbsent": {
      "label": "Опоздания и отсутствия",
      "description": "Сотрудники, опоздавшие или отсутствовавшие в выбранный период."
    },
    "overtime": {
      "label": "Сверхурочные",
      "description": "Сводка сверхурочных часов и оплаты за выбранный период."
    },
    "employeeActivity": {
      "label": "Активность сотрудников",
      "description": "Полный журнал активности, включая все отметки каждого сотрудника."
    },
    "attendanceGrid": {
      "label": "График посещаемости",
      "description": "Месячная матрица с отработанными часами, отпусками, листами нетрудоспособности и отсутствиями по каждому сотруднику."
    },
    "hiring": {
      "label": "Приём на работу",
      "description": "Сотрудники, принятые на работу за выбранный период, с датой приёма и контактами."
    }
  },
  "export": {
    "csv": "Экспорт CSV",
    "excel": "Экспорт Excel",
    "pdf": "Экспорт PDF",
    "downloadFailed": "Не удалось загрузить. Пожалуйста, попробуйте снова.",
    "dismiss": "Закрыть"
  },
  "attendanceGrid": {
    "monthLabel": "Месяц",
    "employeeColumn": "Сотрудник",
    "cell": {
      "vacation": "О",
      "leave": "Б",
      "holiday": "П",
      "present": "Н"
    },
    "legend": {
      "worked": "Отработано (начало–конец)",
      "vacation": "Отпуск",
      "leave": "Отсутствие",
      "holiday": "Праздник",
      "off": "Нерабочий день",
      "present": "Присутствует",
      "workedHours": "Отработано (часы на работе)"
    },
    "view": {
      "label": "Вид",
      "times": "Пришёл / ушёл",
      "hours": "Часы на работе"
    }
  },
  "preview": {
    "selectEmployee": "Выберите сотрудника для предварительного просмотра",
    "selectEmployeeHint": "Используйте выпадающий список сотрудников в панели фильтров.",
    "failedToLoad": "Не удалось загрузить данные отчёта",
    "failedToLoadHint": "Проверьте подключение и попробуйте снова.",
    "noData": "Нет данных за выбранный период",
    "noDataHint": "Измените диапазон дат или фильтр сотрудника и попробуйте снова.",
    "truncatedRows": "Показано первые 50 из {{total}} строк. Для получения всех данных выполните экспорт."
  },
  "advance": {
    "addButton": "Добавить аванс",
    "dialogTitle": "Новый аванс",
    "dateNotice": "Аванс сохраняется с сегодняшней датой.",
    "employeeLabel": "Сотрудник",
    "employeePlaceholder": "Выберите сотрудника",
    "amountLabel": "Сумма (AMD)",
    "noteLabel": "Примечание (необязательно)",
    "errors": {
      "employeeRequired": "Выберите сотрудника.",
      "amountInvalid": "Введите сумму больше 0."
    },
    "toasts": {
      "created": "Аванс сохранён.",
      "createFailed": "Не удалось сохранить аванс. Попробуйте ещё раз.",
      "deleted": "Аванс удалён.",
      "deleteFailed": "Не удалось удалить аванс. Попробуйте ещё раз."
    },
    "listTitle": "Авансы — {{name}}",
    "listEmpty": "За этот период авансов нет.",
    "listTotal": "Итого",
    "deleteAria": "Удалить аванс",
    "confirmDelete": "Удалить этот аванс?",
    "dateLabel": "Дата"
  },
  "columnToggle": {
    "hide": "Скрыть колонку",
    "show": "Показать колонку"
  },
  "groups": {
    "collapse": "Свернуть колонки",
    "expand": "Развернуть колонки",
    "late": {
      "title": "Опоздания",
      "hours": "Часы",
      "deduction": "Удержание (AMD)"
    },
    "earlyLeave": {
      "title": "Ранний уход",
      "hours": "Часы",
      "deduction": "Удержание (AMD)"
    },
    "absence": {
      "title": "Прогулы / за свой счёт",
      "days": "Дни",
      "deduction": "Удержание (AMD)"
    },
    "overtime": {
      "title": "Сверхурочные",
      "hours": "Часы",
      "rate": "Ставка",
      "pay": "Оплата (AMD)"
    }
  },
  "inlineEdit": {
    "saved": "Сохранено.",
    "saveFailed": "Не удалось сохранить. Попробуйте ещё раз.",
    "spSalaryHint": "Действует с {{month}} и далее; прошлые месяцы не меняются."
  }
}
